import React, { useState, useEffect } from "react";
import { NavList } from "../NavList";
import {
  AsideContainer,
  AsideHeaderContainer,
  ToggleAside,
  AsideBodyContainer,
  BackDrop,
} from "./styles";

type AsideProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLElement>,
  HTMLElement
> & {
  logo?: JSX.Element;
  toggle: React.Dispatch<React.SetStateAction<boolean>>;
  state?: boolean;
};

export function Aside({ logo, toggle, state, className = "" }: AsideProps) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLinkClick = () => {
    if (isMobile) {
      toggle(false);
    }
  };

  return (
    <AsideContainer className={className + `${state ? " show" : ""}`}>
      <div>
        <AsideHeaderContainer>
          {logo ? logo : ""}
          {state ? (
            <ToggleAside
              type="checkbox"
              defaultChecked={true}
              aria-label="mostrar ou esconder menu lateral"
            />
          ) : (
            ""
          )}
        </AsideHeaderContainer>
        <AsideBodyContainer>
          <NavList onLinkClick={handleLinkClick} />
        </AsideBodyContainer>
      </div>
      <BackDrop className="backdrop" onClick={() => toggle(false)}></BackDrop>
    </AsideContainer>
  );
}
